import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { AddKnowledgeDocumentRequest, KnowledgeDocument } from '../types/ai';

const URL = '/v2/admin/knowledge';

class KnowledgeService {
  static async getAll(config?: AxiosRequestConfig): Promise<PagedResponse<KnowledgeDocument>> {
    const response = await axios.get(URL, config);
    const list: KnowledgeDocument[] = response.data?.data ?? [];

    return {
      data: {
        data: list,
        meta: {
          size: list.length,
          page: 0,
          limit: list.length,
          firstPage: true,
          lastPage: true,
          pageCount: 1,
        },
      },
    };
  }

  static create(
    data: AddKnowledgeDocumentRequest,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<KnowledgeDocument>> {
    return axios.post(URL, data, config);
  }

  static update(
    id: number,
    data: AddKnowledgeDocumentRequest,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<KnowledgeDocument>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }

  static initializeSampleData(config?: AxiosRequestConfig): Promise<DataResponse<string>> {
    return axios.post(`${URL}/initialize`, undefined, config);
  }
}

export { KnowledgeService };
